import { ColorGradients } from './structure';

export const gradients: ColorGradients = {
  primary:
    'linear-gradient(0.75deg,#e2e2ff 0.71%,rgba(234, 235, 253, 0.76) 38.63%,rgba(242, 243, 254, 0.88) 67.64%,#fafdff 99.43%),#ffffff',
};
